import type { Language } from '../contexts/LanguageContext';

const localeByLanguage: Record<Language, string> = {
  en: 'en-US',
  tr: 'tr-TR',
};

const parseDate = (value: string | Date | null | undefined) => {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatDate = (value: string | Date | null | undefined, language: Language = 'tr'): string => {
  const date = parseDate(value);
  return date ? date.toLocaleDateString(localeByLanguage[language]) : '-';
};

export const formatDateTime = (
  value: string | Date | null | undefined,
  language: Language = 'tr',
  options?: Intl.DateTimeFormatOptions,
): string => {
  const date = parseDate(value);
  return date ? date.toLocaleString(localeByLanguage[language], options) : '-';
};
